export class ConnectRestoreAccountResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccount",
            "baseName": "restoreAccount",
            "type": "RestoreAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectRestoreAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
